var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatmentGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5119 28.9824L29.1166 15.2098L29.1045 8.33196L16.7244 8.35379L16.7099 0.100415L30.4655 0.0761629L30.4922 15.2074L49.7961 41.3091L0.27588 41.3964L12.6244 23.4923L19.5119 28.9824Z",
    fill: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatmentGrayIcon);
export default __webpack_public_path__ + "static/media/statmentGrayIcon.5a73e7f6fb38a4bda7ae73d95cffc2c0.svg";
export { ForwardRef as ReactComponent };